import React from 'react';
import { BRAND_COLOR } from 'appenv';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RoundedButton } from '../../../input/RoundedButton';

const DownloadButton = styled(RoundedButton)`
  background: ${BRAND_COLOR || '#8B383A'};
  padding: 0 24px;
  vertical-align: middle;
  display: inline-flex;
  
  &:disabled {
    opacity: 0.4 !important;
  }
`;


const DownloadAllText = styled.span`
  margin-right: ${({ disabled }) => (disabled ? '8px' : '0')};
`;

const DownloadAllButton = ({ status, onClick }) => (
  <DownloadButton disabled={!!status} onClick={onClick}>
    <DownloadAllText disabled={status}>Download</DownloadAllText>
  </DownloadButton>
);

DownloadAllButton.propTypes = {
  status: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DownloadAllButton;
